let counter = 0

function getStore(vnode) {
    return vnode.context && vnode.context.$store
}

function isOpen(binding) {
    const v = binding.value
    if (v && typeof v === 'object') return !!v.open
    return !!v
}

function getClose(binding) {
    const v = binding.value
    if (v && typeof v === 'object' && typeof v.close === 'function') return v.close
    return null
}

function activate(el, binding, vnode) {
    const store = getStore(vnode)
    if (!store || el._stackActive) return
    el._stackActive = true
    store.commit('pushDialog', el._stackId)
    el._stackUnwatch = store.watch(
        state => state.dialogStack.indexOf(el._stackId) === -1,
        removed => {
            if (!removed || !el._stackActive) return
            el._stackActive = false
            if (el._stackUnwatch) { el._stackUnwatch(); el._stackUnwatch = null }
            if (typeof el._stackClose === 'function') el._stackClose()
        }
    )
}

function deactivate(el, vnode) {
    if (!el._stackActive) return
    el._stackActive = false
    if (el._stackUnwatch) { el._stackUnwatch(); el._stackUnwatch = null }
    const store = getStore(vnode)
    if (store) store.commit('removeDialog', el._stackId)
}

export default {
    bind(el) {
        el._stackId = 'stk_' + (++counter)
        el._stackActive = false
    },
    inserted(el, binding, vnode) {
        el._stackClose = getClose(binding)
        if (isOpen(binding)) activate(el, binding, vnode)
    },
    update(el, binding, vnode) {
        el._stackClose = getClose(binding)
        const open = isOpen(binding)
        if (open && !el._stackActive) activate(el, binding, vnode)
        else if (!open && el._stackActive) deactivate(el, vnode)
    },
    unbind(el, binding, vnode) {
        deactivate(el, vnode)
    },
}
